import React, { MutableRefObject, useState, useEffect, useRef, useContext } from 'react';
import { axios } from '../../utils/apiUtils';
import { useTranslation } from 'react-i18next';
import { Redirect, useHistory, useParams } from 'react-router-dom';

import { getAxiosConfig, iOS } from '../../utils/apiUtils';
import { Container, Modal, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from "react-bootstrap/AccordionContext";

import { propTypes } from 'react-bootstrap/esm/Image';


import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import storiesIcon from '../../assets/images/Cuentos.svg';
import puppetsIcon from '../../assets/images/stories-puppets.svg';
import songsIcon from '../../assets/images/songs.svg';
import poemsIcon from '../../assets/images/poetry.svg';
import meetIcon from '../../assets/images/Conozcamos.svg';
import craftsIcon from '../../assets/images/Manualidades.svg';
import workshopsIcon from '../../assets/images/Talleres.svg';
import gamesIcon from '../../assets/images/Juegos.svg';
import othersIcon from '../../assets/images/Otros.svg';
import loadIcon from '../../assets/images/ajax-loader.gif';
import Experience from '../../components/experience';
import chungungoLogo from '../../assets/images/logotipo-chungungo-flor.svg';
import { Stream, StreamPlayerApi } from '@cloudflare/stream-react';
import ReactHtmlParser from 'react-html-parser';
import { isAllowedToPlayVideo } from '../../utils/authUtils';
import { type } from 'jquery';

const icons = {
  story: storiesIcon,
  puppet: puppetsIcon,
  song: songsIcon,
  poem: poemsIcon,
  meet: meetIcon,
  craft: craftsIcon,
  workshop: workshopsIcon,
  game: gamesIcon,
  other: othersIcon,
}

const styles = {
  videoPlayer: {
    width: '100%',
  },
  description: {
    marginTop: 32,
  },
  experienceIcon: {
    width: 40,
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  titleRow: {

  },
  loadingLayout: {
    width: '100%',
    height: '100%',
  },
  logo: {
    position: 'absolute',
    zIndex: -1,
    top: 150,
    left: 'calc(50% - 100px)',
    textAlign: 'center',
  },
  logoText: {
    marginTop: 12,
    textAlign: 'center',
  },
  logoImg: {
    width: 200
  },
  descMenu: {
    display: 'block',
  },
  btnMenu: {
    display: 'inline',
    textAlign:'left',
    marginRight: 10,
  },
};

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <button
      type="button"
      style={{ backgroundColor: isCurrentEventKey ? '#d14e00' : '#f7ebe4', color: isCurrentEventKey ? '#f8f9fa': '#4a4948', padding: '3px 16px', marginBottom: '10px', fontSize: '12px', fontFamily: 'Roboto', letterSpacing: '0.1em', border: 'none', borderRadius: '2px'}}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

const ExperienceRoute = () => {
  let { id } = useParams();
  let history = useHistory();

  const { t, i18n } = useTranslation();
  const [experience, setExperience] = useState();
  const [experiences, setExperiences] = useState([]);
  const [playerReady, setPlayerReady] = useState(false);
  const [goToSubscription, setGoToSubscription] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [goToExperience, setGoToExperience] = useState();
  const [filter, setFilter] = useState();
  const ref = useRef(null);

  const refreshExperience = () => {
    const axiosConfig = getAxiosConfig();
    axiosConfig.headers = {
      ...axiosConfig.headers,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    };
    axios.get(
      `${process.env.REACT_APP_API_URL}/experiences/${id}`,
      axiosConfig,
    )
      .then((experienceResponse) => {
        setExperience(experienceResponse.data);
      })
      .catch(console.error);
  }

  const refreshExperiences = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/${experience.season._id}/experiences`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((experiencesResponse) => {
        setExperiences(experiencesResponse.data.filter(aExperience => aExperience._id !== experience._id));
      })
      .catch(console.error);
  };
  const refreshFilter = () => {
    //console.log(t.filters);
    axios.get(
      `${process.env.REACT_APP_API_URL}/filters/${id}`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((filterResponse) => {
        //console.log(filterResponse)
        setFilter(filterResponse.data);
      })
      .catch(console.error);
  };

  const sendProgress = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/progress/${id}`,
      {
        progress: ref.current.currentTime,
      },
      getAxiosConfig(),
    )
    .then((progressResponse) => {
      console.debug(`Progress > ${progressResponse.data}`);
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  useEffect(
    () => {
      if (experience)
        refreshExperiences();
        window.scrollTo(0, 0);
    },
    [
      experience
    ],
  )

  useEffect(
    () => {
      refreshFilter();
    },
    [
      id,
    ],
  );

  useEffect(
    () => {
      refreshExperience();
    },
    [
      id,
    ],
  );

  if (goToExperience && history.location.pathname === `/experiences/${goToExperience}`) {
    setGoToExperience(undefined);
  }

  if (goToExperience) {
    return (<Redirect to={`/experiences/${goToExperience}`} push />)
  }

  if (goToSubscription) {
    return <Redirect to="/account/subscribe/confirm" push />
  }

  return (
    <Container>
      <Modal
        show={showSubscribeModal}
        onHide={evt => setShowSubscribeModal(false)}
      >
        <div className="modal-content">
          <div className="modal-body">
            <h5 className="modal-title mb-3" style={{ color: '#692700' }}>
              {t('subscription.modal_onlysubscribers.title')}
            </h5>
            <p>
              {t('subscription.modal_onlysubscribers.message')}
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link" onClick={evt => setShowSubscribeModal(false)}>
              {t('subscription.modal_onlysubscribers.close')}
            </button>
            <button type="button" className="btn btn-outline-success" onClick={evt => setGoToSubscription(true)}>
              {t('subscription.modal_onlysubscribers.subscribe')}
            </button>
          </div>
        </div>
      </Modal>
      {experience &&
        (
          <div
            style={{
              display: (playerReady || !experience || (!experience.isPublic && (!experience.token || experience.token === ''))) ? 'block' : 'none',
            }}
          >
            {(experience.isPublic || (experience.token && experience.token !== '')) &&
              <section className="pt-4 pb-4 mb-5">
                <div className="container">
                  <div className="row">
                    <div className="breadcrumb1 col-12">
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb p-0">
                          <li className="breadcrumb-item" ><a href="/seasons">HOME</a></li>
                          <li className="breadcrumb-item"><a href={`/seasons/${experience.season._id}`}>ESTACIÓN {experience.season.name.toUpperCase()}</a></li>
                          <li className="breadcrumb-item active" aria-current="page">{experience.season.name.toUpperCase()}</li>
                        </ol>
                      </nav>
                    </div>
                    
                    <div className="col-12 hero-video-home center">
                        <Stream
                          streamRef={ref}
                          src={experience.token || experience.videoId}
                          style={styles.videoPlayer} 
                          autoplay="false"
                          controls="true"
                          responsive="true"
                          fluid="true"
                          preload="false"
                          aspectRatio="16:9"
                          onProgress={sendProgress}
                          onEnded={() => {}}
                          onCanPlay={() => setPlayerReady(true)}
                          onLoadStart={(event) => {ref.current.currentTime = experience.progress && !experience.progress.isComplete ? experience.progress.lastStop : undefined}}
                        />
                    </div>

                    <div className="col-12 align-self-start caj-Titulo-Principal pt-3">
                      <span className="icon-headline-1 station-icon"
                        style={{
                          backgroundImage: `url(${icons[experience.experienceType]})`,
                        }}
                      />
                      <h1 className="headline-1">{experience.name}</h1>
                    </div>
                    
                    <div className="col-12 texto-video">
                    <Accordion defaultActiveKey="0">
                      <div style={styles.descMenu}>
                        <div style={styles.btnMenu}>
                          <ContextAwareToggle eventKey="0">Descripción</ContextAwareToggle>
                        </div>
                        {experience.questions &&
                          <div style={styles.btnMenu}>
                            <ContextAwareToggle eventKey="3">Preguntas</ContextAwareToggle>
                          </div>
                        }

                        {experience.requirements &&
                          <div style={styles.btnMenu}>
                            <ContextAwareToggle eventKey="1">¿Qué se necesita?</ContextAwareToggle>
                          </div>
                        }
                        
                        {filter &&
                          <div style={styles.btnMenu}>
                            <ContextAwareToggle eventKey="4">Guía Educativa</ContextAwareToggle>
                          </div>
                        }
                      </div>
                      <div>
                        <Accordion.Collapse eventKey="0">
                          <p className="hero__parrafo col-xs-12 col-lg-9"> { ReactHtmlParser((experience.description || '').replace(/\n/g, '<br/>'))} 
                          <br/>
                          {experience.book && experience.book.label}
                          {experience.book &&
                            <a className="link-book col-8" href={experience.book.link} target="_blank" rel="noreferrer">Ver más</a>
                          }
                          </p>
                        </Accordion.Collapse>
                        {experience.questions &&
                        <Accordion.Collapse eventKey="3">
                          <p className="hero__parrafo col-xs-12 col-lg-9">{ ReactHtmlParser((experience.questions || '').replace(/\n/g, '<br/>'))}</p>
                        </Accordion.Collapse>
                        }

                        {experience.requirements &&
                          <Accordion.Collapse eventKey="1">
                            <p className="hero__parrafo col-xs-12 col-lg-9">{ ReactHtmlParser((experience.requirements || '').replace(/\n/g, '<br/>'))}</p>
                          </Accordion.Collapse>
                        }

                        {experience.skills &&
                          <Accordion.Collapse eventKey="2">
                            <p className="hero__parrafo col-xs-12 col-lg-9">{ ReactHtmlParser((experience.skills || '').replace(/\n/g, '<br/>'))}</p>
                          </Accordion.Collapse>
                        }
                        {filter &&
                          <Accordion.Collapse eventKey="4">
                            <div className="hero__parrafo col-xs-12 col-lg-9">
                              {(filter.comprehensiveCommunication.length > 0 || filter.emotionalSocialDevelop.length > 0 || filter.interactionUnderstandingEnvironment.length > 0) &&
                              <span className="filters-info-title">
                                Núcleos de Aprendizaje
                              </span>
                              }
                              <ul>
                                {filter.comprehensiveCommunication.length > 0 &&
                                <li>
                                  <span>Comunicación Integral: </span>
                                  {filter.comprehensiveCommunication.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )}
                                </li>
                                }
                                {filter.emotionalSocialDevelop.length > 0 &&
                                <li>
                                <span>Desarrollo Emocional y Social: </span>
                                {filter.emotionalSocialDevelop.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )}
                                </li>                                
                                }
                                {filter.interactionUnderstandingEnvironment.length > 0 &&
                                <li>
                                <span>Interacción y Comprensión del Entorno: </span>
                                {filter.interactionUnderstandingEnvironment.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )}
                                </li>                                
                                }
                              </ul>
                              <ul>
                                <li>
                                  <div>
                                  <span className="yellow">Nivel de Edad: </span>
                                  </div>
                                  <div>
                                  {filter.ageLvl.length > 0
                                  ? filter.ageLvl.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )
                                  : (<span>Para todas las edades</span>)
                                  }
                                  </div>
                                </li>
                                <li>
                                  <div>
                                  <span className="yellow">Acciones: </span>
                                  </div>
                                  <div>
                                  {filter.actions.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )}
                                  </div>
                                </li>
                                <li>
                                  <div>
                                  <span className="yellow">Temas: </span>
                                  </div>
                                  <div>
                                  {filter.topics.map((filter)=> (<span>{t(`filters.${filter}`)}</span>) )}
                                  </div>
                                </li>
                              </ul>
                              
                              
                            </div>
                            
                            
                          </Accordion.Collapse>
                        }
                      </div>
                    </Accordion>
                    </div>
                  </div>

                  <div className="row">
                    <div className="tituloSecundario col-12 mt-4 mb-2">
                      <h2 className="headline-2 pr-4">Continuar viendo</h2>
                    </div>
                    {experiences.map((nextExperience) => (
                      <Experience experience={nextExperience} onClick={() => {
                        if (!nextExperience.isPublic && !isAllowedToPlayVideo()) {
                          setShowSubscribeModal(true);
                          return;
                        }
                        setGoToExperience(nextExperience._id);
                        setPlayerReady(false);
                        setExperience(false);
                      }} />
                    ))}
                  </div>
                </div>
              </section>
            }
            {(!experience.isPublic && (!experience.token || experience.token === '')) &&
              <Container>
                <h1
                  style={{
                    paddingTop: 100,
                  }}
                  className="headline-1"
                >Experiencia solo disponible para personas suscritas a Chungungo</h1>
                <a
                  style={{
                    paddingTop: 100,
                    fontSize: '1.5rem',
                  }}
                  href="/account/subscribe/confirm"
                >Suscribirse a Chungungo</a>
              </Container>
            }
          </div>
        )
      }

      {(!experience || !playerReady) && !(experience && !experience.isPublic && (!experience.token || experience.token === '')) &&
        <div
          style={styles.loadingLayout}
        >
          <div
            style={styles.logo}
          >
            <img
              src={chungungoLogo}
              style={styles.logoImg}
              alt="logotipo-empresa" />
            <p
              style={styles.logoText}
            ><strong>Cargando experiencia...</strong></p>
            <img
              style={styles.logoText}
              src={loadIcon}
              alt="loading" />
          </div>
        </div>
      }
    </Container>
        );
};

export default ExperienceRoute;
